"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAG_NAME = void 0;
exports.TAG_NAME = {
    MAX_LENGTH: 20,
    MAX_MESSAGE: 'Tag name cannot exceed 20 characters',
    REQUIRED_MESSAGE: 'Please enter a tag name'
};
//# sourceMappingURL=TAG_NAME.js.map